import React from 'react';
import './ProgressoGeral.scss';

interface ProgressoGeralProps {
  tarefasConcluidas: number;
  totalTarefas: number;
  percentual: number;
}

export const ProgressoGeral: React.FC<ProgressoGeralProps> = ({
  tarefasConcluidas,
  totalTarefas,
  percentual
}) => {
  return (
    <section className="progresso-geral" aria-labelledby="titulo-progresso-geral">
      <h2 className="progresso-geral__title" id="titulo-progresso-geral" tabIndex={0}>Progresso geral</h2>
      <div className="progresso-geral__card">
        <div className="progresso-geral__header">
          <span className="progresso-geral__label" tabIndex={0}>Tarefas concluídas</span>
          <span className="progresso-geral__percentual" tabIndex={0} aria-label={`${percentual} por cento concluído`}>{percentual}%</span>
        </div>
        <div 
          className="progresso-geral__barra"
          role="progressbar"
          aria-valuenow={percentual}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Progresso: ${percentual}% concluído, ${tarefasConcluidas} de ${totalTarefas} tarefas`}
        >
          <div 
            className="progresso-geral__barra-preenchida"
            style={{ width: `${percentual}%` }}
          ></div>
        </div>
        <div className="progresso-geral__footer">
          <span className="progresso-geral__contador" tabIndex={0} aria-label={`${tarefasConcluidas} tarefas concluídas`}>{tarefasConcluidas} concluídas</span>
          <span className="progresso-geral__total" tabIndex={0} aria-label={`${totalTarefas} tarefas no total`}>{totalTarefas} total</span>
        </div>
      </div>
    </section>
  );
};
